<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa"/>
    <div class="content">
      <div class="lebot-welcome text-center">
        <div>
          <loading v-if="!session"/>
          <p class="mt-4">Por favor aguarde, o Bot está sendo iniciado</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TopBar from "@/components/commons/TopBar";
import Loading from "@/components/commons/Loading";

export default {
  components: {Loading, TopBar},

  methods: {
    changeEmpresa(wpp) {
      if (this.isElectron) {
        window.control.toggleWpp({ wpp });
      }
    }
  },

  computed: {
    session() {
      return this.$store.state.session
    },

    empresas() {
      return this.$store.state.empresas
    }
  },

  mounted() {
    if (!this.isElectron) {
      //this.$router.push('/chamados');
    }
  }
}

</script>

<style scoped>
.lebot-welcome {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
